import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import EdgeChartColors from './chart_colors';

import {
  asyncChart,
  defaultNoLeftMenu,
  defaultNoLeftMenuWithAnot,
  defaultBarOptions,
  defaultChartConfiguration,
  defaultChartConfigurationDimension,
  defaultChartConfigurationDimensionV6,
  defaultChartConfigurationDetails,
  defaultsFlexWork,
  defaultStackedBarChartConfiguration,
  defaultStackedBarChartPlusConfiguration,
  defaultLineChartConfiguration,
  setMaxmin,
  formatToOneDecimal,
  benchmarksCustomTooltip,
} from './chart_types_helpers';


Chart.register(annotationPlugin);

sessionStorage.setItem('getOfflinePage', 'false');

let benchmarkChart;
const benchmarkChartCtc = [];
const benchmarkChartPAndP = [];

export default {
  horizontal_bar(element, data, dataLabels, ticks) {
    return new Chart(element, defaultChartConfiguration(ticks, dataLabels, data));
  },

  key_drivers_std_horizontal_bar_noanot(element, data, dataLabels, ticks, showticks = true) {
    return new Chart(element, defaultNoLeftMenu(data, dataLabels, ticks, showticks));
  },

  key_drivers_horizontal_bar(element, data, dataLabels, ticks, showticks = true) {
    return new Chart(element, defaultNoLeftMenuWithAnot(data, dataLabels, ticks, showticks));
  },

  benchmark_chart(element, values, dataLabels, ticks) {
    const graphPay = element[0];
    const ctxPay = graphPay.getContext('2d');
    const gradientBG2 = ctxPay.createLinearGradient(0, 0, ctxPay.canvas.width / 2, 0);
    gradientBG2.addColorStop(1, '#00898C');
    gradientBG2.addColorStop(1, '#00898C');
    gradientBG2.addColorStop(1, '#00898C');
    gradientBG2.addColorStop(1, '#00898C');
    gradientBG2.addColorStop(1, '#00898C');
    return new Chart(ctxPay, {
      responsive: true,
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          data: values,
          backgroundColor: gradientBG2,
          borderColor: '#00898C',
        }],
      },
      options: {
        indexAxis: 'y',
        layout: {
          padding: {
            right: 44,
          },
        },
        scales: {
          x: {
            display: false,
          },
          y: {
            display: false,
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              title() {
                return '';
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toFixed(0)}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value) {
              return `${value.toFixed(0)}%`;
            },
            font: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 12,
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  employee_rating_horizontal_bar(element, data, dataLabels, ticks) {
    return new Chart(element, defaultChartConfiguration(ticks, dataLabels, data, {
    }));
  },

  employee_rating_horizontal_bar_noanot(element, data, dataLabels, ticks) {
    return new Chart(element, defaultChartConfigurationDimension(ticks, dataLabels, data));
  },

  employee_rating_horizontal_bar_noanot_v6(element, data, dataLabels, ticks, customTooltipArray) {
    return new Chart(element, defaultChartConfigurationDimensionV6(ticks, dataLabels, data, customTooltipArray));
  },

  employee_rating_horizontal_bar_dimension(element, data, dataLabels, ticks, showTicks = false) {
    return new Chart(element, defaultChartConfigurationDetails(ticks, dataLabels, data, showTicks));
  },

  retentions_chart(element, data, dataLabels, ticks, bottomTrend) {
    const ydist = bottomTrend;
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: EdgeChartColors.red,
          data,
          label: dataLabels,
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
              document.getElementById('myList').style.display = 'none';
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
            border: {
              display: false,
            },
          },
          y: {
            max: 100,
            grid: {
              display: false,
            },
            border: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                yMin: ydist,
                yMax: ydist,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label1: {
                type: 'label',
                xValue: -0.5,
                yValue: ydist,
                xAdjust: ctx => ctx.chart.chartArea.width,
                yAdjust: 10,
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: [`${ydist.toFixed(0)}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              boxWidth: 14,
              boxHeight: 14,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            color: 'black',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  retentions_chart_noanot(element, data, dataLabels, ticks) {
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: EdgeChartColors.red,
          data,
          label: dataLabels,
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
              document.getElementById('myList').style.display = 'none';
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
            border: {
              display: false,
            },
          },
          y: {
            max: 100,
            grid: {
              display: false,
            },
            border: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              boxWidth: 14,
              boxHeight: 14,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            color: 'black',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  board_members_chart(element, data, _dataLabels, ticks) {
    const ydist = 30;
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          data,
          backgroundColor: [EdgeChartColors.red, EdgeChartColors.turquoise_1],
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            max: 100,
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                yMin: ydist,
                yMax: ydist,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label1: {
                type: 'label',
                xValue: -0.5,
                yValue: ydist,
                xAdjust: ctx => ctx.chart.chartArea.width,
                yAdjust: 10,
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: [`${ydist.toFixed(0)}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  board_members_chart_noanot(element, data, _dataLabels, ticks) {
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          data,
          backgroundColor: [EdgeChartColors.red, EdgeChartColors.turquoise_1],
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            max: 100,
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  vertical_bar_stack_plus_dimension(element, data, dataLabels, ticks) {
    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    const colors = [EdgeChartColors.dark_blue, EdgeChartColors.dark_red, EdgeChartColors.strong_yellow,
      EdgeChartColors.annotations.dark_green, EdgeChartColors.dark_pink, EdgeChartColors.very_dark_cyan,
      EdgeChartColors.moderate_red, EdgeChartColors.strong_orange, EdgeChartColors.very_dark_lime_green,
      EdgeChartColors.very_dark_magenta, EdgeChartColors.very_dark_blue, EdgeChartColors.very_dark_desaturated_orange,
      EdgeChartColors.dark_red_2, EdgeChartColors.dark_yellow, EdgeChartColors.dark_violet,
      EdgeChartColors.strong_orange_2, EdgeChartColors.lime_green, EdgeChartColors.dark_magenta,
      EdgeChartColors.dark_cyan, EdgeChartColors.dark_moderate_violet, EdgeChartColors.very_dark_blue_2,
      EdgeChartColors.moderate_red_2, EdgeChartColors.moderate_green, EdgeChartColors.strong_magenta,
      EdgeChartColors.very_dark_green];

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          data: data[i],
          backgroundColor: (i === dataLabels.length - 1) ? EdgeChartColors.e_blue : colors[i],
          label,
          barPercentage: 0.5,
          categoryPercentage: 1,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }

            setTimeout(() => {
              const image = new Image();

              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
          },
          y: {
            display: false,
            max: 100,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                if (context.dataset.label === 'No employees') {
                  return 'No of employee: 0%';
                }

                if (context.dataset.label.length > 35) {
                  const getFirstPart = context.dataset.label.slice(0, 32);
                  return `${getFirstPart.padEnd(35, '.')} ${parseFloat(context.formattedValue).toPrecision(3)}%`;
                }

                return `${context.dataset.label} ${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              boxWidth: 14,
              padding: 20,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            formatter(value, context) {
              if (value >= 10 && value <= 100 && context.dataset.label !== 'No employees') {
                return `${parseFloat(value).toFixed(1)}%`;
              }
              if (value === 100) {
                return '0.0%';
              }

              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#fff',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  vertical_bar_stack(element, data, dataLabels, ticks) {
    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1, EdgeChartColors.e_blue, EdgeChartColors.gray];
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          data: data[i].map((value) => {
            if (value === 100 && dataLabels[i] === 'Not applicable') {
              return 0;
            }
            if (value === 100 && dataLabels[i] === 'No employees') {
              return 0;
            }
            return value;
          }),
          backgroundColor: colors[i],
          label,
          barPercentage: 0.4,
          categoryPercentage: 1,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        scales: {
          x: {
            display: true,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
            border: {
              display: false,
            },
          },
          y: {
            display: false,
            max: 100,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                if (context.dataset.label === 'No employees' && parseInt(context.formattedValue, 10) === 100) {
                  return 'No of employee 0%';
                }

                if (context.dataset.label === 'Not applicable' && parseInt(context.formattedValue, 10) === 100) {
                  return 'Not applicable';
                }

                return `${context.dataset.label}: ${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              filter(item, chart) {
                return item.text === 'Men' || item.text === 'Women'
                  || (chart.datasets[item.datasetIndex].data.some(val => val !== 0)
                  && item.text === 'No employees');
              },
              color: '#000',
              boxWidth: 14,
              padding: 20,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            offset(context) {
              const dataset = data[context.datasetIndex][context.dataIndex];
              const { label } = context.dataset;
              if (dataset === 100 && (label === 'No employees' || label === 'Not applicable')) {
                return '-14';
              }
              return 0;
            },
            formatter(value, context) {
              if (value >= 12 && value <= 100) {
                return `${parseFloat(value).toFixed(1)}%`;
              }
              if (data[context.datasetIndex][context.dataIndex] === 100 && context.dataset.label === 'Not applicable') {
                return 'NA';
              }
              const s = data[context.datasetIndex][context.dataIndex];
              if (s === 100 && context.dataset.label === 'No employees') {
                return '0.0%';
              }
              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color(context) {
              const dataset = data[context.datasetIndex][context.dataIndex];
              const { label } = context.dataset;
              if (dataset === 100 && label === 'Not applicable') {
                return '#000';
              }
              if (dataset === 100 && label === 'No employees') {
                return '#000';
              }
              return '#fff';
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  stacked_bar_chart(element, data, dataLabels, ticks, barPercentage, categoryPercentage) {
    return new Chart(element, defaultStackedBarChartConfiguration(data, dataLabels, ticks,
      barPercentage, categoryPercentage));
  },

  stacked_bar_chart_plus(element, data, dataLabels, ticks, barPercentage, categoryPercentage) {
    return new Chart(element, defaultStackedBarChartPlusConfiguration(data, dataLabels, ticks,
      barPercentage, categoryPercentage));
  },

  unexplained_gender_pay_gap(element, data, dataLabels, ticks) {
    const [baseSalary, cashBenefits, annot] = data;
    const ydist1 = annot;
    const ydist2 = -annot;

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: [EdgeChartColors.e_blue, EdgeChartColors.e_blue],
          data: [baseSalary, cashBenefits],
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        clip: false,
        layout: {
          padding: {
            top: 60,
            bottom: 40,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
              padding: 20,
            },
            afterFit(scale) {
              scale.height = 70;
            },
          },
          y: {
            display: false,
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                yMin: ydist1,
                yMax: ydist1,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label1: {
                type: 'label',
                drawTime: 'afterDraw',
                xValue: -0.5,
                xAdjust: ctx => ctx.chart.chartArea.width,
                yValue: ydist1,
                yAdjust: (ctx) => {
                  if (ctx.chart.config._config.data.datasets[0].data[0] < 0) return 10;

                  return 10;
                },
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: [`${ydist1}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
              line2: {
                type: 'line',
                yMin: ydist2,
                yMax: ydist2,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label2: {
                type: 'label',
                drawTime: 'afterDraw',
                xValue: -0.5,
                xAdjust: ctx => ctx.chart.chartArea.width,
                yValue: ydist2,
                yAdjust: (ctx) => {
                  if (ctx.chart.config._config.data.datasets[0].data[0] < 0) return 10;

                  return 10;
                },
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: [`${ydist2}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor(context) {
              const value = context.dataset.data[context.dataIndex];
              return value < 0 ? 'start' : 'end';
            },
            align(context) {
              const value = context.dataset.data[context.dataIndex];
              return value < 0 ? 'start' : 'end';
            },
            color: '#000',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              weight: 'bold',
              size: 12,
              family: 'opensans-semibold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },
  unexplained_pay_gap(element, data, dataLabels, ticks) {
    const [baseSalary, cashBenefits] = data;

    let yRange = (Math.abs(baseSalary) > Math.abs(cashBenefits)) ? Math.abs(baseSalary) : Math.abs(cashBenefits);
    yRange = (yRange < 5) ? 5 : yRange;

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: [EdgeChartColors.e_blue, EdgeChartColors.e_blue],
          data: [baseSalary, cashBenefits],
          barPercentage: 0.62,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
            bottom: 24,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
              padding: 20,
            },
            afterFit(scale) {
              scale.height = 70;
            },
          },
          y: {
            display: false,
            min: -yRange,
            max: yRange,
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor(context) {
              const value = context.dataset.data[context.dataIndex];
              return value < 0 ? 'start' : 'end';
            },
            align(context) {
              const value = context.dataset.data[context.dataIndex];
              return value < 0 ? 'start' : 'end';
            },
            color: '#000',
            formatter(value) {
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              weight: 'bold',
              size: 12,
              family: 'opensans-semibold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  flexible_workplace_charts(element, data, dataLabels, ticks) {
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1, EdgeChartColors.red, EdgeChartColors.blue];
    const legendMargin = {
      id: 'legendMargin',
      beforeInit(chart) {
        const fitValue = chart.legend.fit;
        chart.legend.fit = function fit() {
          fitValue.bind(chart.legend)();
          const height = this.height + 30;
          return height;
        };
      },
    };
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          data: data[i],
          label,
          barPercentage: 0.8,
          categoryPercentage: 0.8,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        hover: { mode: null },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
          },
          y: {
            display: false,
            max: 100,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
            align: 'center',
            labels: {
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              boxWidth: 14,
              color: '#000',
            },
          },
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
              label(context) {
                return `${context.dataset.label} ${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter(value, context) {
              if ((data[2] !== undefined) && (data[2][context.dataIndex] === 100)) {
                return 'NA';
              }
              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels, legendMargin],
    });
  },

  flexible_work(element, data, dataLabels, ticks) {
    return new Chart(element, defaultsFlexWork(data, dataLabels, ticks));
  },

  avg_pay_dif_chart(element, data, dataLabels, ticks) {
    const max = Math.round(setMaxmin(data)[1]);
    const min = Math.round(setMaxmin(data)[0]);
    const colors = ['#FBC22F', '#FF6600'];

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          data: data[i],
          backgroundColor: colors[i],
          label,
        })),
      },
      options: defaultBarOptions({
        scales: {
          xAxes: [{
            ticks: {
              maxRotation: 0,
            },
          }],
          yAxes: [{
            ticks: {
              min,
              max,
            },
          }],
        },
      }, null),
    });
  },

  career_transitions_chart_pie(element, { data }, dataLabels, ticks, noPercent = '%') {
    // the chart is built clockwise, therefore men need to come first in order to have women on the left hand side
    const customLegend = {
      id: 'customLegend',
      beforeInit(chart) {
        const htmlOpenTag = '<ul>';
        const htmlCloseTag = '</ul>';
        let resultAllLiTag = '';
        for (let i = 0; i < chart.config._config.data.datasets[0].data.length; i += 1) {
          resultAllLiTag += `<li style="font-family: 'opensans-semibold'; font-size: 13px;  padding-bottom: 10px;">
          <span style="display: inline-block; width:12px; height: 12px; vertical-align: middle; background-color:
          ${chart.config._config.data.datasets[0].backgroundColor[i]}"></span>
          &nbsp;${chart.config._config.data.labels[i]}</li>`;
        }
        const listAllLegends = htmlOpenTag + resultAllLiTag + htmlCloseTag;
        document.getElementById(`${chart.canvas.id}_legend`).innerHTML = listAllLegends;
      },
    };

    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels,
        datasets: [{
          backgroundColor: [EdgeChartColors.dark_blue, EdgeChartColors.dark_red,
            EdgeChartColors.strong_yellow, EdgeChartColors.annotations.dark_green],
          data,
        }],
      },
      options: {
        borderWidth: 0,
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }

            setTimeout(() => {
              const image = new Image();

              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: 35,
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title() {
                return '';
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toFixed(1)}${noPercent}`;
              },
            },
          },
          legend: {
            display: false,
            maxHeight: 800,
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              padding: 20,
              color: '#000',
              font: {
                size: 14,
                weight: 600,
                family: 'opensans-semibold',
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -2,
            formatter(value) {
              if (value >= 4) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 11,
              weight: 600,
              family: 'opensans-semibold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels, customLegend],
    });
  },

  custom_filter_chart_pie(element, { data }, dataLabels, ticks, noPercent = '%') {
    // the chart is built clockwise, therefore men need to come first in order to have women on the left hand side
    const customLegend = {
      id: 'customLegend',
      beforeInit(chart) {
        const htmlOpenTag = '<ul>';
        const htmlCloseTag = '</ul>';
        let resultAllLiTag = '';
        for (let i = 0; i < chart.config._config.data.datasets[0].data.length; i += 1) {
          resultAllLiTag += `<li style="font-family: 'opensans-semibold'; font-size: 13px;  padding-bottom: 10px;">
          <span style="display: inline-block; width:12px; height: 12px; vertical-align: middle; background-color:
          ${chart.config._config.data.datasets[0].backgroundColor[i]}"></span>
          &nbsp;${chart.config._config.data.labels[i]}</li>`;
        }
        const listAllLegends = htmlOpenTag + resultAllLiTag + htmlCloseTag;
        document.getElementById(`${chart.canvas.id}_legend`).innerHTML = listAllLegends;
      },
    };

    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels,
        datasets: [{
          backgroundColor: [EdgeChartColors.dark_blue, EdgeChartColors.dark_red, EdgeChartColors.strong_yellow,
            EdgeChartColors.annotations.dark_green, EdgeChartColors.dark_pink, EdgeChartColors.very_dark_cyan,
            EdgeChartColors.moderate_red, EdgeChartColors.strong_orange, EdgeChartColors.very_dark_lime_green,
            EdgeChartColors.very_dark_magenta, EdgeChartColors.very_dark_blue,
            EdgeChartColors.very_dark_desaturated_orange,
            EdgeChartColors.dark_red_2, EdgeChartColors.dark_yellow, EdgeChartColors.dark_violet,
            EdgeChartColors.strong_orange_2, EdgeChartColors.lime_green, EdgeChartColors.dark_magenta,
            EdgeChartColors.dark_cyan, EdgeChartColors.dark_moderate_violet, EdgeChartColors.very_dark_blue_2,
            EdgeChartColors.moderate_red_2, EdgeChartColors.moderate_green, EdgeChartColors.strong_magenta,
            EdgeChartColors.very_dark_green],
          data,
        }],
      },
      options: {
        borderWidth: 0,
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }

            setTimeout(() => {
              const image = new Image();

              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: 35,
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title() {
                return '';
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toFixed(1)}${noPercent}`;
              },
            },
          },
          legend: {
            display: false,
            maxHeight: 800,
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              padding: 20,
              color: '#000',
              font: {
                size: 14,
                weight: 600,
                family: 'opensans-semibold',
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -2,
            formatter(value) {
              if (value >= 4) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 11,
              weight: 600,
              family: 'opensans-semibold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels, customLegend],
    });
  },

  plus_career_transitions_chart_sy(element, { data }, dataLabels, ticks, noPercent = '%') {
    // the chart is built clockwise, therefore men need to come first in order to have women on the left hand side
    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels.reverse(),
        datasets: [{
          backgroundColor: [
            EdgeChartColors.turquoise_1,
            EdgeChartColors.turquoise_2,
            EdgeChartColors.red,
            EdgeChartColors.red1,
            EdgeChartColors.perception.p6,
            EdgeChartColors.perception.p5,
            EdgeChartColors.lightGray],
          data,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            left: 35,
            right: 35,
          },
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title() {
                return '';
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)} ${noPercent}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -2,
            formatter(value) {
              if (value >= 4) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 12,
              weight: 600,
              family: 'opensans-semibold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  plus_career_transitions_chart_sy_gi(element, { data }, dataLabels, ticks, noPercent = '%') {
    // the chart is built clockwise, therefore men need to come first in order to have women on the left hand side
    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels.reverse(),
        datasets: [{
          backgroundColor: [
            EdgeChartColors.turquoise_1,
            EdgeChartColors.red,
            EdgeChartColors.perception.p6,
            EdgeChartColors.dark_gray],
          data,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            left: 35,
            right: 35,
          },
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title() {
                return '';
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)} ${noPercent}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -2,
            formatter(value) {
              if (value >= 6) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 12,
              weight: 600,
              family: 'opensans-semibold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  career_transitions_chart(element, { data }, dataLabels, ticks, noPercent = '%') {
    // the chart is built clockwise, therefore men need to come first in order to have women on the left hand side
    let colors = [EdgeChartColors.turquoise_1, EdgeChartColors.red];
    if (dataLabels.length > 2) {
      colors = [EdgeChartColors.perception.p6, EdgeChartColors.turquoise_1, EdgeChartColors.red];
    }
    data = data.reverse();
    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels.reverse(),
        datasets: [{
          backgroundColor: colors,
          data,
        }],
      },
      options: {
        animation: {
          duration: Chart.defaults.offscreenRendering ? 0 : 1000,
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            left: 35,
            right: 35,
          },
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title: () => null,
              label(context) {
                if (`${noPercent}` === '%') {
                  return `${parseFloat(context.formattedValue).toPrecision(3)} ${noPercent}`;
                }

                return `${parseFloat(context.formattedValue)}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -2,
            formatter(value) {
              if (`${noPercent}` !== '%') {
                return `${value.toFixed(0)}${noPercent}`;
              }
              if (dataLabels.length > 2) {
                if (value >= 4) {
                  return `${parseFloat(value).toFixed(1)}${noPercent}`;
                }

                return '';
              }
              if (value > 0) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 11,
              weight: 600,
              family: 'opensans-SemiBold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  plus_career_transitions_chart(element, { data }, dataLabels, ticks, noPercent = '%') {
    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels.reverse(),
        datasets: [{
          backgroundColor: [
            EdgeChartColors.turquoise_1,
            EdgeChartColors.turquoise_2,
            EdgeChartColors.red,
            EdgeChartColors.red1,
            EdgeChartColors.lightGray,
          ],
          data,
        }],
      },
      options: {
        layout: {
          padding: {
            left: 35,
            right: 35,
          },
        },
        hover: {
          mode: null,
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title: () => null,
              label(context) {
                if (`${noPercent}` === '%') {
                  return `${parseFloat(context.formattedValue).toPrecision(3)} ${noPercent}`;
                }

                return `${parseFloat(context.formattedValue)}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -1,
            formatter(value) {
              if (`${noPercent}` !== '%') {
                return `${value.toFixed(0)}${noPercent}`;
              }
              if (value >= 4) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 11,
              weight: 600,
              family: 'opensans-SemiBold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  plus_career_transitions_chart_v8(element, { data }, dataLabels, ticks, noPercent = '%') {
    return new Chart(element, {
      type: 'pie',
      data: {
        labels: dataLabels.reverse(),
        datasets: [{
          backgroundColor: [
            EdgeChartColors.red,
            EdgeChartColors.turquoise_1,
            EdgeChartColors.perception.p6,
            EdgeChartColors.natural_grey,
          ],
          data,
        }],
      },
      options: {
        layout: {
          padding: {
            left: 35,
            right: 35,
          },
        },
        hover: {
          mode: null,
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              title: () => null,
              label(context) {
                if (`${noPercent}` === '%') {
                  return `${parseFloat(context.formattedValue).toPrecision(3)} ${noPercent}`;
                }

                return `${parseFloat(context.formattedValue)}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: -1,
            formatter(value) {
              if (`${noPercent}` !== '%') {
                return `${value.toFixed(0)}${noPercent}`;
              }
              if (value >= 4) {
                return `${parseFloat(value).toFixed(1)}${noPercent}`;
              }

              return '';
            },
            font: {
              size: 11,
              weight: 600,
              family: 'opensans-SemiBold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  mentoring_chart(element, data, dataLabels, ticks) {
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1];
    const legendMargin = {
      id: 'legendMargin',
      beforeInit(chart) {
        const fitValue = chart.legend.fit;
        chart.legend.fit = function fit() {
          fitValue.bind(chart.legend)();
          const height = this.height + 30;
          return height;
        };
      },
    };

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          label,
          data: data[i],
          barPercentage: 0.8,
          categoryPercentage: 0.8,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              boxWidth: 14,
              color: '#000',
            },
          },
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter(value, context) {
              if ((data[2] !== undefined) && (data[2][context.dataIndex] === 100)) {
                return 'NA';
              }
              return `${value.toFixed(0)}`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels, legendMargin],
    });
  },

  maternity_retention_rate_chart(element, data, dataLabels, ticks, percent = '%') {
    const yArray = data;
    const yArraySorted = [...yArray].sort((a, b) => b - a);

    const ydist = yArraySorted[0] * 80 / 100;
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: EdgeChartColors.red,
          data,
          barPercentage: 0.6,
          categoryPercentage: 1.0,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        clip: false,
        layout: {
          padding: {
            top: 40,
          },
        },
        hover: { mode: null },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                yMin: ydist,
                yMax: ydist,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label1: {
                type: 'label',
                xValue: -0.5,
                yValue: ydist,
                xAdjust: ctx => ctx.chart.chartArea.width,
                yAdjust: 10,
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: ['80%'],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
            },
          },
          tooltip: {
            yAlign: 'bottom',
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                if (context[0].label.length > 35) {
                  const getFirstPart = context[0].label.slice(0, 32);
                  return getFirstPart.padEnd(35, '.');
                }

                return '';
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: 'black',
            formatter(value) {
              return `${value.toFixed(0)} ${percent}`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  paternity_comparison_chart(element, data, dataLabels, ticks, percent = '%') {
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          backgroundColor: EdgeChartColors.turquoise_1,
          data,
          barPercentage: 0.84,
          categoryPercentage: 0.74,
        }],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                return `${context[0].label.toString().replace(/,/g, ' ')}`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter(value) {
              if (value > 0) {
                return `${value.toFixed(0)} ${percent}`;
              }

              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  parental_leave_duration_chart(element, data, dataLabels, ticks, percent = '%') {
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1];
    const legendMargin = {
      id: 'legendMargin',
      beforeInit(chart) {
        const fitValue = chart.legend.fit;
        chart.legend.fit = function fit() {
          fitValue.bind(chart.legend)();
          const height = this.height + 10;
          return height;
        };
      },
    };

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          data: data[i],
          label,
          barPercentage: 0.84,
          categoryPercentage: 0.74,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
          },
        },
        hover: { mode: null },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
          },
          legend: {
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              padding: 30,
              boxWidth: 14,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter(value) {
              return `${value.toFixed(0)} ${percent}`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#000',
          },
        },
      },
      plugins: [ChartDataLabels, legendMargin],
    });
  },

  performance_rating_chart(element, data, dataLabels, ticks) {
    const colors = [EdgeChartColors.e_blue, EdgeChartColors.turquoise_1, EdgeChartColors.turquoise_2,
      EdgeChartColors.gray];

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          data: data[i].map((value) => {
            if (value === 100 && dataLabels[i] === 'Not applicable') {
              return 0;
            }
            return value;
          }),
          label,
          barPercentage: 0.78,
          categoryPercentage: 0.9,
        })),
      },
      options: {
        interaction: {
          mode: 'index',
        },
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        indexAxis: 'y',
        layout: {
          padding: {
            top: 0,
          },
        },
        scales: {
          x: {
            max: 100,
            stacked: true,
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            stacked: true,
            ticks: {
              padding: 35,
              crossAlign: 'far',
              display: true,
              font: {
                family: 'opensans-semibold',
                size: 16,
                weight: 'bold',
              },
              color: '#000',
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        hover: { mode: null },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              label(context) {
                if (context.dataset.label === 'Not applicable') {
                  return (parseInt(context.formattedValue, 10) === 100) ? 'Not applicable' : '';
                }
                if (context.dataset.label !== 'Not applicable' && (data[3] !== undefined)
                  && (data[3][context.dataIndex] === 100)) {
                  return '';
                }
                return `${context.dataset.label}: ${parseFloat(context.formattedValue).toFixed(1)}%`;
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 14,
              padding: 20,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              filter(item) {
                return item.text === 'Low' || item.text === 'Medium' || item.text === 'High';
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            offset(context) {
              if (context.dataset.label === 'Not applicable') {
                return '-18';
              }
              return 0;
            },
            formatter(value, context) {
              if (value >= 5 && value <= 100) {
                return `${parseFloat(value).toFixed(1)}%`;
              }
              if (data[context.datasetIndex][context.dataIndex] === 100 && context.dataset.label === 'Not applicable') {
                return 'NA';
              }
              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 10,
              weight: 'bold',
            },
            color(context) {
              if (context.dataset.label === 'Not applicable') {
                return '#000';
              }
              return '#fff';
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  perception_chart(element, data, dataLabels, ticks, showTicks = false, key = '') {
    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    let colors = [EdgeChartColors.red, EdgeChartColors.lightred];

    if (key === 'female') {
      colors = [EdgeChartColors.perception.p1, EdgeChartColors.perception.p2];
    } else if (key === 'male') {
      colors = [EdgeChartColors.perception.p3, EdgeChartColors.perception.p4];
    } else if (key === 'non-binary') {
      colors = [EdgeChartColors.perception.p5, EdgeChartColors.perception.p6];
    }
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => (
          {
            backgroundColor: colors[i],
            data: data[i],
            label,
            barPercentage: 1,
            categoryPercentage: 0.8,
          })),
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        aspectRatio: 1,
        indexAxis: 'y',
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            stacked: true,
            border: {
              display: false,
            },
            afterFit(scale) {
              if (showTicks === true) {
                scale.width = 80;
              } else {
                scale.paddingTop = 16;
                scale.paddingBottom = 16;
              }
            },
            grid: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: showTicks,
              crossAlign: 'far',
              font: {
                family: 'opensans-semibold',
                size: 10,
                weight: 'bold',
              },
              color: '#000',
              padding: 4,
            },
          },
        },
        layout: {
          padding: {
            top: 20,
            right: 50,
          },
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value, context) {
              if (context.dataset.backgroundColor === '#c72858' || context.dataset.backgroundColor === '#219498'
                || context.dataset.backgroundColor === '#84d9d9') {
                return '';
              }

              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  perception_chart_ques(element, data, dataLabels, ticks, showTicks = false, key = '') {
    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    let colors = [EdgeChartColors.red, EdgeChartColors.lightred];
    const count = $('.each-perception-bars .each-chart-header').length;
    let fontSize = 12;
    let tickFontSize = 10;
    let scaleWidth = 80;
    let paddingRight = 50;
    if (count === 3 || count === 6) {
      fontSize = 10;
      tickFontSize = 10;
    } else if (count === 2 || count === 4) {
      fontSize = 14;
      tickFontSize = 14;
      scaleWidth = 110;
      paddingRight = 80;
    }

    if (key === 'female') {
      colors = [EdgeChartColors.perception.p1, EdgeChartColors.perception.p2];
    } else if (key === 'male') {
      colors = [EdgeChartColors.perception.p3, EdgeChartColors.perception.p4];
    } else if (key === 'non-binary') {
      colors = [EdgeChartColors.perception.p5, EdgeChartColors.perception.p6];
    }
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => (
          {
            backgroundColor: colors[i],
            data: data[i],
            label,
            barPercentage: 1,
            categoryPercentage: 0.8,
          })),
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        aspectRatio: 1,
        indexAxis: 'y',
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            stacked: true,
            border: {
              display: false,
            },
            afterFit(scale) {
              if (showTicks === true) {
                scale.width = scaleWidth;
              } else {
                scale.paddingTop = 16;
                scale.paddingBottom = 16;
              }
            },
            grid: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: showTicks,
              crossAlign: 'far',
              font: {
                family: 'opensans-semibold',
                size: tickFontSize,
                weight: 'bold',
              },
              color: '#000',
              padding: 4,
            },
          },
        },
        layout: {
          padding: {
            top: 20,
            right: paddingRight,
          },
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value, context) {
              if (context.dataset.backgroundColor === '#c72858' || context.dataset.backgroundColor === '#219498'
                || context.dataset.backgroundColor === '#84d9d9') {
                return '';
              }

              return `${parseFloat(value).toFixed(1)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: fontSize,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  perception_chart_ques_v6(element, data, dataLabels, ticks, showTicks = false, key = '') {
    const countLength = $('.each-perception-bars .each-chart-header').length;
    let fontSize = 12;
    let tickFontSize = 10;
    let scaleWidth = 50;
    let paddingRight = 50;
    if (countLength === 2) {
      fontSize = 14;
      tickFontSize = 14;
      scaleWidth = 50;
      paddingRight = 50;
    }
    const customChartChange = {
      id: 'customChartChange',
      afterDatasetDraw(chart) {
        const { ctx, scales: { x, y } } = chart;
        const count = $('.each-perception-bars .each-chart-header .header-count').length;
        const countGi = $('.each-perception-bars .each-chart-header').length;
        if (count === 2 || count === 4) {
          if ($(`#${element[0].id}`).hasClass('hasHeaderChange')) {
            $('.each-chart-header.adjustSpace').css('marginLeft', `${chart.scales.y.left + 35}px`);
          }
        } else if (countGi === 4 || countGi === 8 || countGi === 5 || countGi === 10 || countGi === 16) {
          if ($(`#${element[0].id}`).hasClass('hasHeaderChange')) {
            $('.each-chart-header.adjustSpace').css('marginLeft', `${chart.scales.y.left + 40}px`);
          }
        }

        for (let i = 0; i < ticks.length; i += 1) {
          if (ticks[i].length > 40) {
            ctx.font = '10px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'right';
            const words = ticks[i].split(' ');
            const midIndex = Math.ceil(words.length / 2);
            const firstPart = words.slice(0, midIndex).join(' ');
            const secondPart = words.slice(midIndex).join(' ');
            ctx.fillText(firstPart, x.getPixelForValue(0) - 40, y.getPixelForValue(i) - 8);
            ctx.fillText(secondPart, x.getPixelForValue(0) - 40, y.getPixelForValue(i) + 10);
          } else {
            ctx.font = '10px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'right';
            ctx.fillText(ticks[i], x.getPixelForValue(0) - 40, y.getPixelForValue(i) + 4);
          }
        }
      },
    };
    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    let colors = [EdgeChartColors.red, EdgeChartColors.lightred];

    if (key === 'female') {
      colors = [EdgeChartColors.perception.p1, EdgeChartColors.white];
    } else if (key === 'male') {
      colors = [EdgeChartColors.turquoise_1, EdgeChartColors.white];
    } else if (key === 'others') {
      colors = [EdgeChartColors.perception.p6, EdgeChartColors.white];
    } else if (key === 'choose_not_to_identify') {
      colors = [EdgeChartColors.dark_gray, EdgeChartColors.white];
    }
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => (
          {
            backgroundColor: colors[i],
            data: data[i],
            label,
            barPercentage: 1,
            categoryPercentage: 0.8,
          })),
      },
      options: {
        indexAxis: 'y',
        hover: { mode: null },
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            display: false,
            stacked: true,
            border: {
              display: false,
            },
            afterFit(scale) {
              if (showTicks === true) {
                scale.width = scaleWidth;
              } else {
                scale.paddingTop = 16;
                scale.paddingBottom = 0;
              }
            },
            grid: {
              drawBorder: false,
              display: false,
            },
            ticks: {
              display: showTicks,
              crossAlign: 'far',
              font: {
                family: 'opensans-semibold',
                size: tickFontSize,
                weight: 'bold',
              },
              color: '#000',
              padding: 4,
            },
          },
        },
        layout: {
          padding(context) {
            if (key === 'female' || key === 'others') {
              return { top: 20, right: paddingRight, left: 200 };
            }

            return { top: 20, right: paddingRight, left: 0 };
          },
          // padding: {
          //     top: 20,
          //     left: 50,
          // },
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter(value, context) {
              if (context.dataset.backgroundColor === '#ffffff') {
                return '';
              }

              return `${value.toFixed(0)}%`;
            },
            font: {
              family: 'opensans-semibold',
              size: fontSize,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels, customChartChange],
    });
  },

  representation_requirement_std_chart(element, data, dataLabels, ticks) {
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1, EdgeChartColors.gray];

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          data: data[i].map((value) => {
            if (value === 100 && dataLabels[i] === 'Not applicable') {
              return 0;
            }
            if (value === 100 && dataLabels[i] === 'No employees') {
              return 0;
            }
            return value;
          }),
          label,
          barPercentage: 0.4,
          categoryPercentage: 1,
        })),
      },
      options: {
        interaction: {
          mode: 'index',
        },
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              crossAlign: 'far',
              padding: 10,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
          },
        },
        clip: false,
        layout: {
          padding: {
            top: 40,
            right: 40,
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            callbacks: {
              label(context) {
                if (context.dataset.label === 'Not applicable') {
                  return (parseInt(context.formattedValue, 10) === 100) ? 'Not applicable' : '';
                }
                if (context.dataset.label !== 'Not applicable' && (data[2] !== undefined)
                  && (data[2][context.dataIndex] === 100)) {
                  return '';
                }

                return `${context.dataset.label}  ${parseFloat(context.formattedValue).toFixed(1)}%`;
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 14,
              boxHeight: 14,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              filter(item) { return item.text === 'Men' || item.text === 'Women'; },
            },
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                xMin: 30,
                xMax: 30,
                borderColor: '#750223',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label1: {
                type: 'label',
                drawTime: 'afterDraw',
                xValue: 30,
                yValue: 0,
                yAdjust: -20,
                xAdjust: 20,
                backgroundColor: '#750223',
                position: 'end',
                color: '#fff',
                content: [`${30}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-bold',
                  weight: 'bold',
                  size: 12,
                },
              },
              line2: {
                type: 'line',
                xMin: 70,
                xMax: 70,
                borderColor: '#005d60',
                borderWidth: 2,
                borderDash: [8, 6],
              },
              label2: {
                type: 'label',
                drawTime: 'afterDraw',
                xValue: 70,
                yValue: 0,
                yAdjust: -20,
                xAdjust: 20,
                backgroundColor: '#005d60',
                position: 'end',
                color: '#fff',
                content: [`${30}%`],
                borderRadius: 17,
                padding: 6,
                font: {
                  family: 'opensans-semibold',
                  weight: 'bold',
                  size: 12,
                },
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            offset(context) {
              if (context.dataset.label === 'Not applicable' || context.dataset.label === 'No employees') {
                return '-20';
              }
              return 0;
            },
            formatter(value, context) {
              if (value >= 14 && value <= 100) {
                return `${parseFloat(value).toFixed(1)}%`;
              }
              if (data[context.datasetIndex][context.dataIndex] === 100 && context.dataset.label === 'Not applicable') {
                return 'NA';
              }
              const s = data[context.datasetIndex][context.dataIndex];

              if (s === 100 && context.dataset.label === 'No employees') {
                return '0.0%';
              }
              return '';
            },
            color(context) {
              const dataset = data[context.datasetIndex][context.dataIndex];
              const { label } = context.dataset;
              if (dataset === 100 && label === 'Not applicable') {
                return '#000';
              }
              if (dataset === 100 && label === 'No employees') {
                return '#000';
              }
              return '#fff';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  representation_requirement_std_chart_noanot(element, data, dataLabels, ticks) {
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1, EdgeChartColors.gray];

    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: dataLabels.map((label, i) => ({
          backgroundColor: colors[i],
          data: data[i].map((value) => {
            if (value === 100 && dataLabels[i] === 'Not applicable') {
              return 0;
            }
            if (value === 100 && dataLabels[i] === 'No employees') {
              return 0;
            }
            return value;
          }),
          label,
          barPercentage: 0.5,
          categoryPercentage: 1,
        })),
      },
      options: {
        interaction: {
          mode: 'index',
        },
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
              document.getElementById('myList2').style.display = 'none';
            }, 0);
          },
        },
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              crossAlign: 'far',
              padding: 10,
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              label(context) {
                if (context.dataset.label === 'Not applicable') {
                  return (parseInt(context.formattedValue, 10) === 100) ? 'Not applicable' : '';
                }
                if (context.dataset.label !== 'Not applicable' && (data[2] !== undefined)
                  && (data[2][context.dataIndex] === 100)) {
                  return '';
                }

                return `${context.dataset.label}: ${parseFloat(context.formattedValue).toFixed(1)}%`;
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              filter(item) { return item.text === 'Men' || item.text === 'Women'; },
              boxWidth: 12,
              boxHeight: 12,
              color: '#000',
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            offset(context) {
              if (context.dataset.label === 'Not applicable' || context.dataset.label === 'No employees') {
                return '-20';
              }
              return 0;
            },
            formatter(value, context) {
              if (value >= 14 && value <= 100) {
                return `${parseFloat(value).toFixed(1)}%`;
              }
              if (data[context.datasetIndex][context.dataIndex] === 100 && context.dataset.label === 'Not applicable') {
                return 'NA';
              }
              const s = data[context.datasetIndex][context.dataIndex];

              if (s === 100 && context.dataset.label === 'No employees') {
                return '0.0%';
              }
              return '';
            },
            color(context) {
              const dataset = data[context.datasetIndex][context.dataIndex];
              const { label } = context.dataset;
              if (dataset === 100 && label === 'Not applicable') {
                return '#000';
              }
              if (dataset === 100 && label === 'No employees') {
                return '#000';
              }
              return '#fff';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  },

  bench_mark_peer_chart: function benchmarkPeerChart(element, data, dataLabels, ticks, noPercSym = false,
    gender = null) {
    const inWeeksString = '(in weeks)';
    const percSym = (tick = null) => ((tick && tick.includes(inWeeksString)) || noPercSym === true ? '' : '%');
    const ticksText = data[4] || ['Total', 'Operational', 'Junior mgmt', 'Middle mgmt', 'Upper mgmt', 'Top mgmt'];
    const ticksTextSm = data[3] || ['Total', 'Ops', 'JM', 'MM', 'UM', 'TM'];
    const existingChartIndex = benchmarkChartCtc.findIndex(chart => chart.canvas.id === element[0].id);
    if (existingChartIndex !== -1) {
      benchmarkChartCtc[existingChartIndex].destroy();
      benchmarkChartCtc.splice(existingChartIndex, 1);
    }
    const containsWomen = ticks.some(tick => /\swomen/i.test(tick));
    const containsMen = ticks.some(tick => /\smen/i.test(tick));
    const containsBoth = containsWomen && containsMen;
    let colors = [];

    if (containsBoth) {
      colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1];
    } else if (containsWomen || gender === 'women') {
      colors = [EdgeChartColors.red];
    } else {
      colors = [EdgeChartColors.turquoise_1];
    }

    const barGrowthVertical = {
      id: 'barGrowth',
      afterDatasetDraw: function afterDatasetDraw(chart) {
        const { ctx } = chart;
        const _chart$scales3 = chart.scales;
        const { x } = _chart$scales3;
        const { y } = _chart$scales3;
        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]));
          ctx.lineTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
          ctx.strokeStyle = '#b1b1b1';
          ctx.stroke();
          ctx.fill();
          ctx.restore();
        }
        for (let _a4 = 0; _a4 < chart.config._config.data.datasets[0].data.length; _a4 += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(_a4),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) - 6);
          ctx.lineTo(x.getPixelForValue(_a4) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 2);
          ctx.lineTo(x.getPixelForValue(_a4) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 2);
          ctx.moveTo(x.getPixelForValue(_a4),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 8);
          ctx.lineTo(x.getPixelForValue(_a4) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 2);
          ctx.lineTo(x.getPixelForValue(_a4) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 2);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(''.concat(formatToOneDecimal(chart.config._config.data.datasets[0].data[_a4][0]),
            percSym(ticks[_a4])),
          x.getPixelForValue(_a4) + 38, y.getPixelForValue(chart.config._config.data.datasets[0].data[_a4][0]) + 1);
        }
        for (let _a5 = 0; _a5 < chart.config._config.data.datasets[0].data.length; _a5 += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(_a5),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) - 2);
          ctx.lineTo(x.getPixelForValue(_a5) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 4);
          ctx.lineTo(x.getPixelForValue(_a5) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 4);
          ctx.moveTo(x.getPixelForValue(_a5),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 10);
          ctx.lineTo(x.getPixelForValue(_a5) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 4);
          ctx.lineTo(x.getPixelForValue(_a5) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 4);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(''.concat(formatToOneDecimal(chart.config._config.data.datasets[0].data[_a5][2]),
            percSym(ticks[_a5])),
          x.getPixelForValue(_a5) + 38, y.getPixelForValue(chart.config._config.data.datasets[0].data[_a5][2]) + 10);
        }
        for (let _a6 = 0; _a6 < chart.config._config.data.datasets[0].data.length; _a6 += 1) {
          ctx.beginPath();
          ctx.arc(x.getPixelForValue(_a6), y.getPixelForValue(chart.config._config.data.datasets[0].data[_a6][1]),
            6, 0, 2 * Math.PI);
          ctx.fillStyle = '#595959';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(''.concat(formatToOneDecimal(chart.config._config.data.datasets[0].data[_a6][1]),
            percSym(ticks[_a6])),
          x.getPixelForValue(_a6) + 38, y.getPixelForValue(chart.config._config.data.datasets[0].data[_a6][1]) + 10);
        }
        if (chart.config._config.data.datasets[1].data.length === (ticksText.length * 2)) {
          for (let i = 0; i < chart.config._config.data.datasets[1].data.length; i += 2) {
            ctx.font = '14px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            ctx.fillText(ticksText[i / 2], x.getPixelForValue(i) + 40, y.getPixelForValue(0) + 24);
          }
        }
        if (chart.config._config.data.datasets[1].data.length === ticksTextSm.length) {
          for (let _i2 = 0; _i2 < chart.config._config.data.datasets[1].data.length; _i2 += 1) {
            ctx.font = '14px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            if (ticksTextSm[_i2].length > 20) {
              const words = ticksTextSm[_i2].split(' ');
              const thirdIndex = Math.ceil(words.length / 3); // Calculate the index for one-third of the array
              const part1 = words.slice(0, thirdIndex).join(' '); // First third
              const part2 = words.slice(thirdIndex, thirdIndex * 2).join(' '); // Second third
              const part3 = words.slice(thirdIndex * 2).join(' '); // Remaining words for the third part
              ctx.fillText(part1, x.getPixelForValue(_i2), y.getPixelForValue(0) + 24);
              ctx.fillText(part2, x.getPixelForValue(_i2), y.getPixelForValue(0) + 44);
              ctx.fillText(part3, x.getPixelForValue(_i2), y.getPixelForValue(0) + 64);
            } else {
              ctx.fillText(ticksTextSm[_i2], x.getPixelForValue(_i2), y.getPixelForValue(0) + 26);
            }
          }
        }
      },
    };
    const newChart = new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [{
          data: data[1],
          order: 1,
          categoryPercentage: 0.05,
          backgroundColor: 'transparent',
        }, {
          data: data[0],
          backgroundColor: colors,
          categoryPercentage: containsBoth ? 0.1 : 0.3,
          maxBarThickness: 30,
          order: 0,
        }],
      },
      options: {
        animation: {
          onComplete: function onComplete(_ref35) {
            const { canvas } = _ref35.chart;
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector('#'.concat(target)).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 30,
            left: 30,
            right: 30,
            bottom: 80,
          },
        },
        x: {
          stacked: true,
          ticks: {
            display: true,
            font: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 14,
            },
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: false,
            ticks: {
              display: true,
              color: '#000',
              font: {
                family: 'opensans-semibold',
                size: 14,
              },
            },
            offset: true,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            max: 100,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            filter: function filter(tooltipItem) {
              return tooltipItem.datasetIndex === 1;
            },
            callbacks: {
              label: function label(context) {
                return ''.concat(formatToOneDecimal(parseFloat(context.formattedValue)),
                  percSym(ticks[context.dataIndex]));
              },
            },
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'left',
            offset: 17,
            color: '#000',
            formatter: function formatter(value, context) {
              if (context.dataset.backgroundColor.length > 0) {
                if (context.dataset.data.length > 6) {
                  if (context.dataset.backgroundColor[1] === '#AC0235'
                    || context.dataset.backgroundColor[0] === '#00898C') {
                    return ''.concat(formatToOneDecimal(value), percSym(ticks[context.dataIndex]));
                  }
                } else if (context.dataset.backgroundColor[0] === '#AC0235'
                  || context.dataset.backgroundColor[0] === '#00898C') {
                  return ''.concat(formatToOneDecimal(value), percSym(ticks[context.dataIndex]));
                }
              }
              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              padding: 40,
              font: {
                family: 'opensans-medium',
                size: 10,
                weight: '500',
              },
              color: '#000',
              usePointStyle: true,
              generateLabels: function generateLabels() {
                const labels = [{
                  label: dataLabels[0],
                  pointStyle: 'rectRot',
                  size: 1,
                  color: EdgeChartColors.lightGray,
                }, {
                  label: dataLabels[1],
                  pointStyle: 'circle',
                  size: 1,
                  color: EdgeChartColors.darkGray,
                }, {
                  label: dataLabels[2],
                  pointStyle: 'rectRot',
                  size: 1,
                  color: EdgeChartColors.lightGray,
                }];
                return labels.map((label, index) => ({
                  text: label.label,
                  pointStyle: label.pointStyle,
                  strokeStyle: label.color,
                  fillStyle: label.color,
                  lineWidth: label.size,
                  index,
                }));
              },
            },
          },
        },
      },
      plugins: [ChartDataLabels, barGrowthVertical],
    });
    benchmarkChartCtc.push(newChart);
    return newChart;
  },

  bench_mark_peer_policies_practices_chart(element, data, dataLabels, ticks, showticks) {
    const existingChartIndex = benchmarkChartPAndP.findIndex(chart => chart.canvas.id === element[0].id);
    if (existingChartIndex !== -1) {
      benchmarkChartPAndP[existingChartIndex].destroy();
      benchmarkChartPAndP.splice(existingChartIndex, 1);
    }
    const colors = [];
    for (let i = 0; i < data[0].length; i += 1) {
      if (data[0][i] === 100) {
        colors[i] = EdgeChartColors.turquoise;
      } else {
        colors[i] = EdgeChartColors.e_blue;
      }
    }

    const barGrowthVertical = {
      id: 'barGrowth',
      afterDatasetDraw(chart) {
        const { ctx, scales: { x, y } } = chart;

        for (let i = 0; i < ticks.length; i += 1) {
          if (ticks[i].length > 50) {
            ctx.font = '14px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'left';
            const words = ticks[i].split(' ');
            const midIndex = Math.ceil(words.length / 2);
            const firstPart = words.slice(0, midIndex).join(' ');
            const secondPart = words.slice(midIndex).join(' ');
            ctx.fillText(firstPart, x.getPixelForValue(0) - 400, y.getPixelForValue(i) - 10);
            ctx.fillText(secondPart, x.getPixelForValue(0) - 400, y.getPixelForValue(i) + 10);
          } else {
            ctx.font = '14px opensans-semibold';
            ctx.fillStyle = '#000';
            ctx.textAlign = 'left';
            ctx.fillText(ticks[i], x.getPixelForValue(0) - 400, y.getPixelForValue(i) + 10);
          }
        }
      },
    };

    const newChart = new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [
          {
            data: data[1],
            backgroundColor: colors,
            categoryPercentage: 0.6,
            order: 0,
          },
        ],
      },
      options: {
        indexAxis: 'y',
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 0,
            right: 100,
            left: 400,
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: false,
            max: 100,
            ticks: {
              display: true,
              color: '#000',
              font: {
                family: 'opensans-semibold',
                size: 14,
              },
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            stacked: true,
            border: {
              display: false,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              color: '#000',
              font: {
                family: 'opensans-semibold',
                size: 14,
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label(context) {
                return `${formatToOneDecimal(parseFloat(context.formattedValue))}%`;
              },
            },
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
          },
          datalabels: {
            anchor: 'end', // Anchor the label to the end of the bar
            align: 'end', // Align the label to the start (top) of the anchor
            color: '#000',
            offset: 8,
            formatter(value, context) {
              if (context.dataset.backgroundColor.length > 0 && context.dataset.backgroundColor !== 'transparent') {
                return `${formatToOneDecimal(value)}%`;
              }

              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              padding: 40,
              font: {
                family: 'opensans-medium',
                size: 10,
                weight: '500',
              },
              color: '#000',
              usePointStyle: true,
              generateLabels() {
                const labels = [
                  {
                    label: dataLabels[0],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                  {
                    label: dataLabels[1],
                    pointStyle: 'circle',
                    size: 1,
                    color: EdgeChartColors.darkGray,
                  },
                  {
                    label: dataLabels[2],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                ];
                return labels.map((label, index) => ({
                  text: label.label,
                  pointStyle: label.pointStyle,
                  strokeStyle: label.color,
                  fillStyle: label.color,
                  lineWidth: label.size,
                  index,
                }));
              },
            },
          },
        },
      },
      plugins: [ChartDataLabels, barGrowthVertical],
    });
    benchmarkChartPAndP.push(newChart);
    return newChart;
  },


  bench_mark_chart_dow_jones(element, data, dataLabels, ticks) {
    if (benchmarkChart) {
      benchmarkChart.destroy();
    }
    const barGrowth = {
      id: 'barGrowth',
      afterDatasetDraw(chart) {
        const { ctx, scales: { x, y } } = chart;
        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]));
          ctx.lineTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
          ctx.strokeStyle = '#b1b1b1';
          ctx.stroke();
          ctx.fill();
          ctx.restore();
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) - 6);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 8);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][0]}%`, x.getPixelForValue(a) + 40,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 1);
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) - 2);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][2]}%`, x.getPixelForValue(a) + 40,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.arc(x.getPixelForValue(a),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][1]), 6, 0, 2 * Math.PI);
          ctx.fillStyle = '#595959';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][1]}%`,
            x.getPixelForValue(a) + 40, y.getPixelForValue(chart.config._config.data.datasets[0].data[a][1]) + 10);
        }
      },
    };

    benchmarkChart = new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [
          {
            data: data[1],
            order: 1,
            categoryPercentage: 0.05,
            backgroundColor: 'grey',
          },
          {
            data: data[0],
            backgroundColor: '#AC0235',
            categoryPercentage: 0.28,
            order: 0,
          },
        ],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 4000);
          },
        },
        layout: {
          padding: 20,
        },
        x: {
          stacked: true,
          ticks: {
            display: true,
            font: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 14,
            },
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              color: '#000',
              font: {
                size: 14,
              },
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            max: 100,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            filter(tooltipItem) {
              return tooltipItem.datasetIndex === 1;
            },
            callbacks: {
              title(context) {
                return `${context.length ? context[0].label.toString().replace(/,/g, ' ') : ''}`;
              },
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'left',
            color: '#000',
            offset: 24,
            formatter(value, context) {
              if (context.dataset.backgroundColor === '#AC0235') {
                return `${parseFloat(value).toFixed(1)}%`;
              }

              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
              font: {
                family: 'opensans-medium',
                size: 10,
                weight: 500,
              },
              color: '#000',
              usePointStyle: true,
              generateLabels() {
                const labels = [
                  {
                    label: dataLabels[0],
                    pointStyle: 'rect',
                    size: 1,
                    color: EdgeChartColors.red,
                  },
                  {
                    label: dataLabels[1],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                  {
                    label: dataLabels[2],
                    pointStyle: 'circle',
                    size: 1,
                    color: EdgeChartColors.darkGray,
                  },
                  {
                    label: dataLabels[3],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                ];
                return labels.map((label, index) => ({
                  text: label.label,
                  pointStyle: label.pointStyle,
                  strokeStyle: label.color,
                  fillStyle: label.color,
                  lineWidth: label.size,
                  index,
                }));
              },
            },
          },
        },
      },
      plugins: [ChartDataLabels, barGrowth],
    });
    return benchmarkChart;
  },

  bench_mark_chart_dow_jones_report(element, data, dataLabels, ticks) {
    const barGrowthIndustry = {
      id: 'barGrowthIndustry',
      afterDatasetDraw(chart) {
        const { ctx, scales: { x, y } } = chart;
        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]));
          ctx.lineTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
          ctx.strokeStyle = '#b1b1b1';
          ctx.stroke();
          ctx.fill();
          ctx.restore();
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) - 6);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 8);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 2);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][0]}%`, x.getPixelForValue(a) + 40,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][0]) + 1);
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) - 2);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.moveTo(x.getPixelForValue(a), y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
          ctx.lineTo(x.getPixelForValue(a) - 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.lineTo(x.getPixelForValue(a) + 6,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 4);
          ctx.fillStyle = '#b1b1b1';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][2]}%`, x.getPixelForValue(a) + 40,
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][2]) + 10);
        }

        for (let a = 0; a < chart.config._config.data.datasets[0].data.length; a += 1) {
          ctx.beginPath();
          ctx.arc(x.getPixelForValue(a),
            y.getPixelForValue(chart.config._config.data.datasets[0].data[a][1]), 6, 0, 2 * Math.PI);
          ctx.fillStyle = '#595959';
          ctx.fill();
          ctx.restore();
          ctx.font = '12px opensans-regular';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(`${chart.config._config.data.datasets[0].data[a][1]}%`,
            x.getPixelForValue(a) + 40, y.getPixelForValue(chart.config._config.data.datasets[0].data[a][1]) + 10);
        }
      },
    };

    benchmarkChart = new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks,
        datasets: [
          {
            data: data[1],
            order: 1,
            categoryPercentage: 0.05,
            backgroundColor: 'grey',
          },
          {
            data: data[0],
            backgroundColor: '#AC0235',
            categoryPercentage: 0.28,
            order: 0,
          },
        ],
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
            }, 0);
          },
        },
        layout: {
          padding: 20,
        },
        x: {
          stacked: true,
          ticks: {
            display: true,
            font: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 14,
            },
          },
        },
        scales: {
          x: {
            border: {
              display: false,
            },
            display: true,
            ticks: {
              display: true,
              color: '#000',
              font: {
                size: 14,
              },
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            border: {
              display: false,
            },
            max: 100,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            filter(tooltipItem) {
              return tooltipItem.datasetIndex === 1;
            },
            callbacks: {
              label(context) {
                return `${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'left',
            color: '#000',
            offset: 24,
            formatter(value, context) {
              if (context.dataset.backgroundColor === '#AC0235') {
                return `${parseFloat(value).toFixed(1)}%`;
              }

              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
              font: {
                family: 'opensans-medium',
                size: 10,
                weight: 500,
              },
              color: '#000',
              usePointStyle: true,
              generateLabels() {
                const labels = [
                  {
                    label: dataLabels[0],
                    pointStyle: 'rect',
                    size: 1,
                    color: EdgeChartColors.red,
                  },
                  {
                    label: dataLabels[1],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                  {
                    label: dataLabels[2],
                    pointStyle: 'circle',
                    size: 1,
                    color: EdgeChartColors.darkGray,
                  },
                  {
                    label: dataLabels[3],
                    pointStyle: 'rectRot',
                    size: 1,
                    color: EdgeChartColors.lightGray,
                  },
                ];
                return labels.map((label, index) => ({
                  text: label.label,
                  pointStyle: label.pointStyle,
                  strokeStyle: label.color,
                  fillStyle: label.color,
                  lineWidth: label.size,
                  index,
                }));
              },
            },
          },
        },
      },
      plugins: [ChartDataLabels, barGrowthIndustry],
    });
    return benchmarkChart;
  },

  async_bench_mark_chart_dow_jones(element, jsonurl, dataLabels, ticks, colors, title) {
    asyncChart(jsonurl, (data) => {
      this.bench_mark_chart_dow_jones(element, data, dataLabels, ticks);
    });
  },

  projection_scenario_simulator(element, data, dataLabels, axisLabels) {
    Chart.defaults.scale.grid.display = true;
    Chart.defaults.scale.ticks.display = true;
    return new Chart(element, defaultLineChartConfiguration(data, dataLabels, axisLabels));
  },

  vertical_bar_comparison(element, data, dataLabels, ticks) {
    let countTimes = 0;
    let paddingBottomSpace;

    function splitLines(text, maxlen) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = '';
      let prevCount = 0;
      words.forEach((word) => {
        if ((currentLine + word).length > maxlen) {
          lines.push(currentLine.trim());
          currentLine = '';
          prevCount += 1;
          if (prevCount >= countTimes) {
            countTimes += 1;
          }
        }
        currentLine += `${word} `;
      });
      if (currentLine.trim().length > 0) {
        lines.push(currentLine.trim());
        prevCount += 1;
        if (prevCount >= countTimes) {
          countTimes += 1;
        }
      }
      paddingBottomSpace = 20 * countTimes;
      return lines;
    }

    const trimmedTicks = ticks.map(label => (
      label.length > 100 ? `${label.slice(0, 100)}...` : label));

    const customeTickValues = {
      id: 'customeTickValues',
      afterDatasetDraw(chart) {
        const { ctx, scales: { x, y } } = chart;
        for (let i = 0; i < trimmedTicks.length; i += 1) {
          ctx.font = '14px opensans-semibold';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          let eachLine = '';
          if ($(window).width() < 1300) {
            eachLine = splitLines(trimmedTicks[i], 8);
          } else {
            eachLine = splitLines(trimmedTicks[i], 14);
          }
          eachLine = eachLine.filter(item => item.trim() !== '');
          let adjustPositionCount = 0;
          let count = false;
          let j = 0;

          for (j = 0; j < eachLine.length; j += 1) {
            if (eachLine[j] !== '') {
              adjustPositionCount = j;

              if (eachLine[j].indexOf(' ') === -1 && eachLine[j].length >= 19) {
                const midIndex = Math.floor(eachLine[j].length / 2);
                const firstWord = eachLine[j].substring(0, midIndex);
                const secondWord = eachLine[j].substring(midIndex);
                const indexB = eachLine.indexOf(eachLine[j]);

                if (indexB !== -1) {
                  eachLine.splice(indexB, 1);
                }

                eachLine.splice(j, 0, firstWord, secondWord);
                j -= 1;
              } else {
                ctx.fillText(eachLine[j], x.getPixelForValue(i), y.getPixelForValue(0) + (j + 1) * 20);
                count = false;
              }
            }
          }
        }
        chart.config._config.options.layout.padding.bottom = paddingBottomSpace;
        chart.update();
      },
    };

    Chart.defaults.scale.grid.display = false;
    Chart.defaults.scale.ticks.display = false;
    const colors = [EdgeChartColors.red, EdgeChartColors.turquoise_1, EdgeChartColors.e_blue];
    return new Chart(element, {
      type: 'bar',
      data: {
        labels: ticks.map(tick => tick.split(' ')),
        datasets: dataLabels.map((label, i) => ({
          data: data[i],
          backgroundColor: colors[i],
          label,
          barPercentage: 0.4,
          categoryPercentage: 1,
        })),
      },
      options: {
        animation: {
          onComplete: ({ chart: { canvas } }) => {
            const target = canvas.getAttribute('data-target');
            if (!target) {
              return;
            }
            setTimeout(() => {
              const image = new Image();
              image.src = canvas.toDataURL('image/png');
              document.querySelector(`#${target}`).appendChild(image);
              document.getElementById('myList1').style.display = 'none';
            }, 0);
          },
        },
        layout: {
          padding: {
            top: 40,
            bottom: 65,
          },
        },
        scales: {
          x: {
            display: true,
            stacked: true,
            ticks: {
              display: false,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
            },
          },
          y: {
            display: false,
            max: 100,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                family: 'opensans-semibold',
                weight: 'bold',
                size: 14,
              },
              color: '#000',
              callback(value) {
                return `${value}%`;
              },
            },
          },
        },
        plugins: {
          tooltip: {
            titleFont: {
              family: 'opensans-semibold',
              weight: 'bold',
              size: 16,
            },
            bodyFont: {
              family: 'opensans-regular',
              weight: 'normal',
              size: 16,
            },
            boxHeight: 14,
            callbacks: {
              title(context) {
                const raw = `${context[0].label.toString().replace(/,/g, ' ')}`;
                const maxLen = 80;

                const words = raw.split(' ');
                const lines = [];
                let current = '';

                words.forEach((w) => {
                  if ((current + (current ? ' ' : '') + w).length <= maxLen) {
                    current += (current ? ' ' : '') + w;
                  } else {
                    if (current) lines.push(current);
                    current = w;
                  }
                });
                if (current) lines.push(current);

                return lines;
              },
              label(context) {
                return `${context.dataset.label}: ${parseFloat(context.formattedValue).toPrecision(3)}%`;
              },
            },
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              font: {
                family: 'opensans-semibold',
                size: 14,
                weight: 'bold',
              },
              color: '#000',
              boxWidth: 14,
              padding: 20,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            formatter(value, context) {
              if (value > 0 && value <= 100) {
                return `${value.toFixed(1)}%`;
              }
              return '';
            },
            font: {
              family: 'opensans-semibold',
              size: 12,
              weight: 'bold',
            },
            color: '#fff',
          },
        },
      },
      plugins: [ChartDataLabels, customeTickValues],
    });
  },
};
